import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import StPaul from './pages/About/StPaul';
import History from './pages/About/History';
import NewsPage from './pages/About/News';
import Album from './pages/About/Album';
import ChurchFathers from './pages/About/ChurchFathers';
import FatherDetail from './pages/About/FatherDetail';
import ChurchCouncil from './pages/About/ChurchCouncil';
import Education from './pages/Services/Education';
import Mass from './pages/Mass/Mass';
import Schedule from './pages/Mass/Schedule';
import Library from './pages/Library/Library';
import Donations from './pages/Donations/Donations';
import GlobalStyle from './styles/GlobalStyle';
import Header from './components/Header/Header';
import Navigation from './components/Navigation/Navigation';
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import EducationDetail from './pages/Services/EducationDetail';
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import ManageNews from './pages/Admin/ManageNews';
import ManageFathers from './pages/Admin/ManageFathers';
import AdminFatherDetail from './pages/Admin/AdminFatherDetail';
import ManageSettings from './pages/Admin/ManageSettings';
import ManageTicker from './pages/Admin/ManageTicker';
import ManageEvents from './pages/Admin/ManageEvents';
import ManageServices from './pages/Admin/ManageServices';
import AdminServiceDetail from './pages/Admin/AdminServiceDetail';
import ManageMassSchedule from './pages/Admin/ManageMassSchedule';
import ManageCouncil from './pages/Admin/ManageCouncil';
import ManageAlbum from './pages/Admin/ManageAlbum';
import ServicePage from './pages/Services/ServicePage';
import ManageAbout from './pages/Admin/ManageAbout';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (max-width: 768px) {
    padding: 0 0.5rem;
  }
`;

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <GlobalStyle />
        <AppContainer>
          <Header />
          <Navigation />
          <MainContent>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/about/stpaul" element={<StPaul />} />
              <Route path="/about/history" element={<History />} />
              <Route path="/about/news" element={<NewsPage />} />
              <Route path="/about/album" element={<Album />} />
              <Route path="/about/fathers" element={<ChurchFathers />} />
              <Route path="/about/fathers/:id" element={<FatherDetail />} />
              <Route path="/about/council" element={<ChurchCouncil />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/education" element={<Education />} />
              <Route path="/services/education/:classId" element={<EducationDetail />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/mass" element={<Mass />} />
              <Route path="/mass/schedule" element={<Schedule />} />
              <Route path="/library" element={<Library />} />
              <Route path="/donations" element={<Donations />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/news"
                element={
                  <ProtectedRoute>
                    <ManageNews />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/fathers"
                element={
                  <ProtectedRoute>
                    <ManageFathers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/fathers/:id"
                element={
                  <ProtectedRoute>
                    <AdminFatherDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <ProtectedRoute>
                    <ManageSettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/ticker"
                element={
                  <ProtectedRoute>
                    <ManageTicker />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/events"
                element={
                  <ProtectedRoute>
                    <ManageEvents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/services"
                element={
                  <ProtectedRoute>
                    <ManageServices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/services/:id"
                element={
                  <ProtectedRoute>
                    <AdminServiceDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/mass-schedule"
                element={
                  <ProtectedRoute>
                    <ManageMassSchedule />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/council"
                element={
                  <ProtectedRoute>
                    <ManageCouncil />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/album"
                element={
                  <ProtectedRoute>
                    <ManageAlbum />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/about"
                element={
                  <ProtectedRoute>
                    <ManageAbout />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </MainContent>
          <Footer />
          <WhatsAppButton />
        </AppContainer>
      </Router>
    </AuthProvider>
  );
};

export default App;
